import React from 'react';
import { ShieldIcon } from 'lucide-react';
export const PublicSafetyWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-2010">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2011">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2012">
          <ShieldIcon className="h-5 w-5 text-red-500 mr-2" data-id="element-2013" />
          Public Safety
        </h2>
      </div>
      <div className="p-6" data-id="element-2014">
        <div className="flex flex-col space-y-4" data-id="element-2015">
          <div className="flex justify-between items-center" data-id="element-2016">
            <span className="text-sm text-gray-600" data-id="element-2017">
              Bylaw Violation Reports
            </span>
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2018">
              7
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2019">
            <span className="text-sm text-gray-600" data-id="element-2020">
              Fire Safety Inspections
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2021">
              4
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2022">
            <span className="text-sm text-gray-600" data-id="element-2023">Active Event Permits</span>
            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2024">
              3
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-2025">
            <p className="text-xs text-gray-700 font-medium" data-id="element-2026">Upcoming Events</p>
            <div className="mt-2 text-xs text-gray-600" data-id="element-2027">
              <p data-id="element-2028">• Downtown Festival - June 18-20</p>
              <p data-id="element-2029">• Marathon - June 25</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-2030">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2031">
          View Compliance Dashboard
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2032">
          Manage Event Permits
        </a>
      </div>
    </div>;
};